<script setup lang="ts">
import type { News } from '~/models/news';
import dayjs from 'dayjs';
import { useUserFetch } from '~/composables/useUserApi';
const { data: news, refresh, pending } = await useUserFetch<News[]>('/api/news');
  const filteredNews = computed(() => {
    return news.value?.filter(news => (!news.to || dayjs(news.to).isAfter(dayjs())) && (!news.from || dayjs(news.from).isBefore(dayjs())));
});
</script>
<template>
  <div class="p-4 mainColor container mx-auto max-w-screen-lg">
    <SectionHeader header="Velkommen til Sarpsborgveien legesenter"  >
      
    </SectionHeader>
    

    <div v-if="!pending" class="flex flex-col gap-6">
      <div v-for="newsItem in filteredNews" :key="newsItem.id">
        <div class="gradient-background">

          <div class="mainColor flex flex-row justify-between gap-2 p-4">
            <h2 class="text-xl md:text-2xl font-bold">{{ newsItem.title }}</h2>
            <div class="flex flex-row gap-2">
              <span class="text-sm mb-2">Opprettet: {{ dayjs(newsItem.createdAt).format('DD.MM.YYYY') }}</span>
              <span class="text-sm mb-2" v-if="newsItem.updatedAt">Oppdatert: {{ dayjs(newsItem.updatedAt).format('DD.MM.YYYY') }}</span>
            </div>
          </div>
          <div class="col-span-3 px-6 py-8">
            <div v-html="newsItem.content" class="mb-2 mainColor"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
